export default function PendingApproval() {
  return (
    <div className="max-w-md mx-auto px-4 py-24 text-center">
      <div className="text-6xl mb-6">⏳</div>
      <h1 className="font-display text-2xl font-bold text-slate-100 mb-3">Your seat in the grove awaits</h1>
      <p className="text-slate-400 text-sm leading-relaxed">
        Your account is pending admin approval. You'll gain access to your family constellations
        as soon as the keeper opens the gate — or sign in again with an invite code for instant entry.
      </p>
    </div>
  )
}
